import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import { CHANGE_COLLAPSE_BOX } from "@Broker/@Modules/browser-preferences/store/browser-preferences-actions";
import { IS_BOX_EXPANDED } from "@Broker/@Modules/browser-preferences/store/browser-preferences-getters";
import { CURRENT_USER_USERNAME } from "@Broker/@Modules/main/store/account/account-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CollapsibleCard",
  props: {
    collapseId: {
      type: String,
      required: true
    },
    storePath: {
      type: String,
      required: true
    },
    showIndicator: {
      type: Boolean,
      default: true
    },
    bodyClass: {
      type: String,
      default: ""
    },
    cardStyle: {
      type: Boolean,
      default: true
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("BrowserPreferencesStore", [IS_BOX_EXPANDED])), mapGetters("AccountStore", [CURRENT_USER_USERNAME])), {}, {
    visible: {
      set(value) {
        if (value) this.handleShow();else this.handleHide();
      },
      get() {
        return this.IS_BOX_EXPANDED({
          username: this.CURRENT_USER_USERNAME,
          collapseComponentName: this.storePath
        });
      }
    },
    slotBindings() {
      return {
        collapsed: !this.visible
      };
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions("BrowserPreferencesStore", [CHANGE_COLLAPSE_BOX])), {}, {
    handleShow() {
      this.CHANGE_COLLAPSE_BOX({
        collapseComponentName: this.storePath,
        isCollapsed: true
      });
      this.$emit("show");
    },
    handleHide() {
      this.CHANGE_COLLAPSE_BOX({
        collapseComponentName: this.storePath,
        isCollapsed: false
      });
      this.$emit("hide");
    }
  })
});